import Vue from 'vue'
import VueAuth from '@websanova/vue-auth'
import router from '@/routers'
import store from '@/store'

Vue.router = router

Vue.use(VueAuth, {
  auth: {
    request (req, token) {
      this.options.http._setHeaders.call(this, req, { Authorization: 'Bearer ' + token })
    },
    response: res => (res.data || {}).accessToken
  },
  http: require('@websanova/vue-auth/drivers/http/axios.1.x.js'),
  router: require('@websanova/vue-auth/drivers/router/vue-router.2.x.js'),
  refreshData: { enabled: false },
  loginData: { url: '/auth/login', method: 'POST', redirect: '/start', fetchUser: true },
  fetchData: { url: '/auth/me', method: 'GET', enabled: true },
  parseUserData: (data) => {
    store.commit('setIsSidebarEnabled', true
    //  data.role === 'osda'
    )
    return data
  },
  tokenDefaultName: 'auth_token',
  rolesVar: 'role'
})
